
export const VIEW_TYPES = {
    SET_CHAT_HEADER: "SET_CHAT_HEADER",
    CHANGE_INVITED_WERKERS: "CHANGE_INVITED_WERKERS",
    JOB_CARD_SEARCH_TEXT: "JOB_CARD_SEARCH_TEXT",
    ASSOCIATES_SEARCH_TEXT: "ASSOCIATES_SEARCH_TEXT",
    CLONE_JOB_DATA: "CLONE_JOB_DATA",
};
export const ASSOCIATESTATUS_TYPES = {
    RequestSent: "RequestSent",
    RequestReceived: "RequestReceived",
    Declined: "Declined",
    Cancelled: "Cancelled",
    Fired: "Fired",
    Associate: "Associate",
};
export const HEADERTEXT_TYPES = {
    Home: "Home",
    Associates: "Associates",
    Profile: "Profile",
    AssociatesProfile: "Associates Profile",
    EditJob: "Edit Job",
    EditProfile: "Edit Profile",
    ShiftDetails: "Job Summary",
    ScheduleJob: "Schedule Job",
    ChooseWerkers: "Choose Werkers",
    AnnouncementSelectWerkers: "Select Recipients",
    Announcement: "Announcement",
    AnnouncementDetail: "Announcement Detail",
    CreateAnnouncement: "Create Announcement",
    EditAnnouncement: "Edit Announcement",
    SelectAudience: "Select Audience",
    Chat: "Chat",
    Chats: "Chats",
    Messages: "Messages",
    CloneJob: "Clone Job",
    AddWerkerToShift: "Add Werker to Shift",
    NewMessage: "New Message",
    Notifications: "Notifications",
    AdminView: "Admin View",
    Community: "Community",
    Payments: "Payments",
};
export const PUSH_NOTIFICATION_TYPES = {
    SchedulerAddedWerkerToShift: "SchedulerAddedWerkerToShift",
    DirectMessage: "DirectMessage",
    JobMessage: "JobMessage",
    AssociationRequest: "AssociationRequest",
    WerkerJobAvailable: "WerkerJobAvailable",
    WerkerJobReminder: "WerkerJobReminder",
    SchedulerFilledJobs: "SchedulerFilledJobs",
    SchedulerUnFilledJobs: "SchedulerUnFilledJobs",
    SchedulerRemovedWerkerFromShift: "SchedulerRemovedWerkerFromShift",
    SchedulerEditedJob: "SchedulerEditedJob",
    WerkerPaymentReceived: "WerkerPaymentReceived",
    SchedulerNewAssociateFromInvite: "SchedulerNewAssociateFromInvite",
};
export const WORKFLOW_WERKER_TYPES = {
    // An empty string ("") only occurs on the schedulers job card.
    Invited: "Invited",
    Scheduled: "Scheduled",
    Past: "Past",
    Uninvited: "Uninvited",
    Expired: "Expired",
    Fired: "Fired",
    Cancelled: "Cancelled",
    Deleted: "Deleted",
};
export const WORKFLOW_SCHEDULER_TYPES = {
    Open: "Open",
    Filled: "Filled",
    Past: "Past",
    Deleted: "Deleted",
};
export const FB_COLLECTION_PATH = {
    // replace hard-coded firebase string paths with these controlled types
    JobsDocs: "jobsDocs",
    Users: "users",
    UserAssociations : "userAssociations",
    UsersPublicFacing : "users_PublicFacing",
    Chats : "chats",
    Chat : "chat",
    JobFeed: "jobFeed",
    AnnouncementFeed: "announcementFeed",
    Announcements: "announcements",
    Notifications: "notifications",
    Crews: "crews",
    InviteCodes: "inviteCodes",
    SavedDummies: "savedDummies",
};
export const WERK_SEGMENT_SELECTOR = {
    WerkerInvited: "werkerinvited",
    WerkerScheduled: "werkerscheduled",
    WerkerPast: "werkerpast",
    SchedOpen: "schedopen",
    SchedFilled: "schedfilled",
    SchedPast: "schedpast"
};
export const WORKFLOW_FEED_TYPES = {
    // Lowercase feed action values used in jobFeed updates (distinct from PascalCase workflow status types)
    Scheduled: "scheduled",
    Filled: "filled",
    Cancelled: "cancelled",
    Expired: "expired",
    Deleted: "deleted",
    Active: "active",
};
export const ANNOUNCEMENT_STATUS = {
    Active: "active",
    Deleted: "deleted",
};
export const CSS_STYLING = {
    // Standardize the styling across the application
    
}